const VideoGalleryClass = function (id) {
  this.id = `#shopify-section-${id}`;
  this.activeVideoContainer = document.querySelector(`${this.id} .active-video`);
  this.player = document.querySelector(`${this.id} video.active-player`);
  this.toggle = document.querySelector(`${this.id} .player__button.toggle`);
  this.fullScreen = document.querySelector(`${this.id} .player__button.full`);
  this.progress = document.querySelector(`${this.id} .progress-bar`);
  this.timeline = document.querySelector(`${this.id} .timeline`);
  this.volumeRate = document.querySelector(`${this.id} .player__slider.volumeRate-bar`);
  this.volumeBtn = document.querySelector(`${this.id} .player__button.volume`);
  this.volumeContainer = document.querySelector(`${this.id} .volume-container`);
  this.playBtn = document.querySelector(`${this.id} .active-video .Icon.Icon--play`);
  this.controlBar = document.querySelector(`${this.id} .control_bar`);
  this.videoSlides = document.querySelector(`${this.id} .video-gallery__slides`);
  this.isPaused = false;

  this.addEventListenersToSection();
  this.activateSlider();
};

const vp = VideoGalleryClass.prototype;

vp.togglePlay = function () {
  this.activeVideoContainer.classList.add('play');
  const fullScreenModeOn = (window.innerHeight == screen.height);
  const method = this.player.paused ? 'play' : 'pause';
  const isMobile = window.matchMedia('(max-width: 750px)').matches;
  if (!fullScreenModeOn) this.player[method]();
  if (isMobile) this.fullScreenRequest();
};

vp.updateButton = function () {
  if (this.player.paused) {
    this.toggle.classList.remove('Btn_pause');
  } else {
    this.toggle.classList.add('Btn_pause');
  }
  this.hideVolumeRate();
};

vp.fullScreenRequest = function () {
  const fullScreenMethod = this.player.webkitRequestFullscreen || this.player.requestFullscreen || this.player.mozRequestFullScreen || this.msRequestFullscreen
  fullScreenMethod.call(this.player)

  this.hideVolumeRate();
};

vp.updateTimeline = function () {
  const currentHour = Math.floor(this.player.currentTime / 60 / 60);
  const currentMinute = Math.floor(this.player.currentTime / 60 % 60);
  const currentSecond = Math.floor(this.player.currentTime % 60);

  const durationHour = Math.floor(this.player.duration / 60 / 60);
  const durationMinute = Math.floor(this.player.duration / 60 % 60);
  const durationSeconds = Math.floor(this.player.duration % 60);

  this.timeline.textContent = `
    ${currentHour > 0 ? `${String(currentHour).padStart(2, '0')}:` : ''}${String(currentMinute).padStart(2, '0')}:${String(currentSecond).padStart(2, '0')} | 
    ${durationHour > 0 ? `${String(durationHour).padStart(2, '0')}:` : ''}${String(durationMinute).padStart(2, '0')}:${String(durationSeconds).padStart(2, '0')}`;
};

vp.handleProgress = function () {
  if (this.player.style.backgroundImage != "none") {
    this.player.style.backgroundImage = "none";
  }
  const percent = (this.player.currentTime / this.player.duration) * 1000;
  if (!this.isPaused) this.progress.value = percent;

  this.updateTimeline();
};

vp.updateProgress = function () {
  this.player.currentTime = this.progress.value / 1000 * this.player.duration;
};

vp.pauseOnMouseDown = function () {
  this.isPaused = true;
};

vp.resumeOnMouseUp = function () {
  this.isPaused = false;
};

vp.updateVolume = function () {
  if (this.volumeRate.value == 0) {
    this.volumeBtn.classList.add('Btn_mute');
  } else {
    this.volumeBtn.classList.remove('Btn_mute');
  }
  this.player.volume = this.volumeRate.value / 100;
};

vp.hideVolumeRate = function () {
  this.volumeContainer.classList.remove('rate-active');
};

vp.toggleVolumeRate = function () {
  this.volumeContainer.classList.toggle('rate-active');
};

vp.startVideo = function () {
  this.activeVideoContainer.classList.add('play');
  this.player.play();
};

vp.changeVideo = function (e) {
  const selectedVideo = e.target.closest('.video-gallery__slide');
  const selectedVideosrc = selectedVideo.dataset.src;
  const selectedVideoPoster = selectedVideo.style.backgroundImage;
  this.activeVideoContainer.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})

  selectedVideo.setAttribute('data-src', this.player.src);
  selectedVideo.style.backgroundImage = this.player.style.backgroundImage;

  this.player.src = selectedVideosrc;
  this.player.style.backgroundImage = selectedVideoPoster;
  
  this.startVideo();
}; 

vp.addEventListenersToSection = function () {
  this.player.addEventListener('click', this.togglePlay.bind(this));
  this.toggle.addEventListener('click', this.togglePlay.bind(this));
  this.player.addEventListener('play', this.updateButton.bind(this));
  this.player.addEventListener('pause', this.updateButton.bind(this));
  this.fullScreen.addEventListener('click', this.fullScreenRequest.bind(this));
  this.player.addEventListener('timeupdate', this.handleProgress.bind(this));
  this.progress.addEventListener('change', this.updateProgress.bind(this));
  this.progress.addEventListener('mousedown', this.pauseOnMouseDown.bind(this));
  this.progress.addEventListener('mouseup', this.resumeOnMouseUp.bind(this));
  this.volumeRate.addEventListener('change', this.updateVolume.bind(this));
  this.volumeBtn.addEventListener('click', this.toggleVolumeRate.bind(this));
  this.player.addEventListener('durationchange', this.updateTimeline.bind(this));
};

vp.activateSlider = function () {
  const isMobile = window.matchMedia('(max-width: 750px)').matches;
  if (!window.videoImageBlocks) return;

  if (isMobile) {
    new Flickity(this.videoSlides, { 
      // options
      pageDots: false,
      wrapAround: true,
      autoPlay: 5000,
      prevNextButtons: false,
      cellAlign: "left",
    });
  }
};

const initVideoGallery = function () {
  const sections = window.videoGallerySettings;
  if (!sections?.length) return;
  sections.forEach((sectionId) => {
    new VideoGalleryClass(sectionId);
  });
};

export default initVideoGallery;
